import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

type TooltipProps = PropsWithChildren<{
  tooltipChildren?: React.ReactNode
}>

const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
`

const TooltipSyle = styled.div`
  background-color: var(--on-dark);
  color: var(--on-light);
  padding: 5px;
  border-radius: 3px;
  font-size: 14px;
  position: absolute !important;
  z-index: 1;
  left: -125px;
  width: 250px;
  transform: translateX(-50%);
  display: block;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s, visibility 0.2s;
  pointer-events: none;
  top: -25px !important;
  ${TooltipContainer}:hover & {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
  }
`

const Tooltip = ({ tooltipChildren, children }: TooltipProps) => {
  return (
    <TooltipContainer>
      {children}
      <TooltipSyle>{tooltipChildren}</TooltipSyle>
    </TooltipContainer>
  )
}

export default Tooltip
